import React, { useEffect, useRef, useState } from "react";
import ReactHtmlParser from "react-html-parser";
import { format as formatWhatsapp } from "@flasd/whatsapp-formatting";
import { messageType } from "../../../../utils/models/message";
import * as S from "../styles";
import { traitText } from "modules/app/utils/models/anchor-text";
import { File } from "../File";
import * as storage from "../../../../utils/storage";
import AudioType from "./ItemTypes/AudioType";
import VideoType from "./ItemTypes/VideoType";
import ImageType from "./ItemTypes/ImageType";

export function MessageType({ message, setShowImage }) {
  const [url, setUrl] = useState("");
  const type = messageType(message);

  useEffect(() => {
    if (message?.attachment_content_type) {
      storage
        .getFileURI(message)
        .then((url) => setUrl(url))
        .catch(() => setUrl(message.attachment_url));
    }
  }, []);

  switch (type) {
    case "audio":
      return <AudioType url={url} />;

    case "video":
      return <VideoType url={url} />;

    case "image":
      return (
        <ImageType
          url={url}
          setShowImage={() => setShowImage(message.attachment_url)}
        />
      );

    case "component":
      return message.body;

    case "file":
      return (
        <File
          from={message.from}
          url={url}
          attachment_content_type={message.attachment_content_type}
          body={message.body}
        />
      );

    default:
      const body = traitText(message.body);

      return <S.Text>{ReactHtmlParser(formatWhatsapp(body))}</S.Text>;
  }
}
